import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import request from '../utils/request';
import { setAdminInfo, setToken } from '../store/slices/adminSlices';
import { FiLinkedin, FiCheck, FiAlertCircle } from 'react-icons/fi';

export default function LinkedInOAuthCallback() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { search } = useLocation();
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    (async () => {
      try {
        await request.get(`/social/oauth/linkedin/callback${search}`, { withCredentials: true });

        const auth = await request.get('/auth/me', { withCredentials: true });
        if (auth.data?.user) dispatch(setAdminInfo(auth.data.user));
        if (auth.data?.token) dispatch(setToken(auth.data.token));

        setStatus('success');
        setTimeout(() => navigate('/social'), 1500);
      } catch (err) {
        console.error('LinkedIn OAuth callback failed', err);
        setStatus('error');
        setTimeout(() => navigate('/social?linkedin_error=1'), 3000);
      }
    })();
  }, [dispatch, search, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-zinc-50">
      <div className="text-center">
        {status === 'loading' && (
          <>
            <div className="w-14 h-14 rounded-2xl bg-[#0A66C2]/10 flex items-center justify-center mx-auto mb-4">
              <FiLinkedin className="w-7 h-7 text-[#0A66C2] animate-pulse" />
            </div>
            <p className="text-sm text-zinc-500">Finalizing LinkedIn connection...</p>
          </>
        )}
        {status === 'success' && (
          <>
            <div className="w-14 h-14 rounded-2xl bg-emerald-100 flex items-center justify-center mx-auto mb-4">
              <FiCheck className="w-7 h-7 text-emerald-600" />
            </div>
            <p className="text-sm font-medium text-emerald-700">LinkedIn connected successfully!</p>
            <p className="text-xs text-zinc-400 mt-1">Redirecting...</p>
          </>
        )}
        {status === 'error' && (
          <>
            <div className="w-14 h-14 rounded-2xl bg-red-100 flex items-center justify-center mx-auto mb-4">
              <FiAlertCircle className="w-7 h-7 text-red-600" />
            </div>
            <p className="text-sm font-medium text-red-700">Connection failed</p>
            <p className="text-xs text-zinc-400 mt-1">Redirecting back...</p>
          </>
        )}
      </div>
    </div>
  );
}
